import { ASSESSMENT_SLUG } from "core/consts";
import { useGetOntology } from "core/model/utils/ontologies/hooks";
import { Auction, GetOntologyType } from "core/types";
import { useEncryption } from "dsl/atoms/Contexts";
import {
  BodyWrapper,
  EncryptedField,
  OntologyValue,
  PatientProfileInfoCard,
  StringField,
} from "dsl/organisms/PatientProfileDetailsShared/shared";
import { useTranslations } from "translations";
import Translations from "translations/types";
import { PatientInfoSlugContext } from "../PatientProfileDetailsShared";

export function AdmissionsGeneralInformation({
  getOntology,
  isSealdOnly,
  translations,
  value,
  withEncryptionAccess,
}: {
  getOntology: GetOntologyType;
  isSealdOnly: boolean;
  translations: Translations;
  value: Auction | null | undefined;
  withEncryptionAccess: boolean;
}) {
  return (
    <>
      <BodyWrapper>
        <b className="-mr-3 font-bold">{`${translations.careproviderApp.recareAdmissionsForm.patientInformation.genderTitle}${translations.general.colon} `}</b>
        {value?.patient?.profile?.gender ? (
          <OntologyValue
            getOntology={getOntology}
            type="gender"
            value={value.patient.profile.gender}
          />
        ) : (
          <StringField
            testId="gender-unknown"
            value={translations.careproviderApp.recareAdmissionsProfile.unknown}
          />
        )}
      </BodyWrapper>
      <EncryptedField
        bold
        isSealdOnly={isSealdOnly}
        prefix={
          translations.careproviderApp.recareAdmissionsForm.patientInformation
            .firstNameLabel
        }
        testId="first_name"
        value={value?.patient?.profile?.first_name}
        withEncryptionAccess={withEncryptionAccess}
      />
      <EncryptedField
        bold
        isSealdOnly={isSealdOnly}
        prefix={
          translations.careproviderApp.recareAdmissionsForm.patientInformation
            .lastNameLabel
        }
        testId="last_name"
        value={value?.patient?.profile?.last_name}
        withEncryptionAccess={withEncryptionAccess}
      />
      <EncryptedField
        bold
        isSealdOnly={isSealdOnly}
        prefix={
          translations.careproviderApp.recareAdmissionsForm.patientInformation
            .birthDateLabel
        }
        testId="birth_date"
        value={value?.patient?.profile?.birth_date}
        withDateString
        withEncryptionAccess={withEncryptionAccess}
      />
    </>
  );
}

export function AdmissionsPatientCard({ auction }: { auction: Auction }) {
  const getOntology = useGetOntology();
  const translations = useTranslations();
  const { isSealdOnly, withEncryptionAccess } = useEncryption();

  return (
    <PatientInfoSlugContext.Provider
      value={{
        assessmentSlug: ASSESSMENT_SLUG.INFO,
        auctionId: auction.id,
        patientId: auction.patient.id,
      }}
    >
      <PatientProfileInfoCard
        testId="general_information_category_container"
        title={
          translations.careproviderApp.recareAdmissionsForm.patientInformation
            .pageTitle
        }
      >
        <AdmissionsGeneralInformation
          getOntology={getOntology}
          isSealdOnly={isSealdOnly}
          translations={translations}
          value={auction}
          withEncryptionAccess={withEncryptionAccess}
        />
      </PatientProfileInfoCard>
    </PatientInfoSlugContext.Provider>
  );
}
